import { addDays, format, subDays } from "date-fns";

export const MOCK_USERS = [
  {
    id: "u1",
    name: "Alice Freeman",
    role: "Frontend Dev",
    avatar: "https://picsum.photos/seed/u1/64/64",
  },
  {
    id: "u2",
    name: "Bob Smith",
    role: "Backend Lead",
    avatar: "https://picsum.photos/seed/u2/64/64",
  },
  {
    id: "u3",
    name: "Charlie Davis",
    role: "Designer",
    avatar: "https://picsum.photos/seed/u3/64/64",
  },
  {
    id: "u4",
    name: "Diana Prince",
    role: "Product Owner",
    avatar: "https://picsum.photos/seed/u4/64/64",
  },
  {
    id: "u5",
    name: "Evan Wright",
    role: "QA Engineer",
    avatar: "https://picsum.photos/seed/u5/64/64",
  },
];

export const MOCK_PROJECTS = [
  {
    id: "p1",
    name: "Website Redesign",
    description: "Overhaul of the main corporate website with new branding.",
    key: "WEB",
    status: "Active",
    createdAt: subDays(new Date(), 30).toISOString(),
    color: "bg-indigo-600",
    columns: ["Backlog", "To Do", "In Progress", "Review", "Done"],
  },
  {
    id: "p2",
    name: "Mobile App V2",
    description:
      "Flutter migration and new feature implementation for iOS/Android.",
    key: "MOB",
    status: "Active",
    createdAt: subDays(new Date(), 45).toISOString(),
    color: "bg-green-600",
    columns: ["Backlog", "To Do", "In Progress", "Review", "Done"],
  },
  {
    id: "p3",
    name: "Internal Dashboard",
    description: "Analytics tools for the admin team.",
    key: "DASH",
    status: "Active",
    createdAt: subDays(new Date(), 10).toISOString(),
    color: "bg-amber-600",
    columns: ["Backlog", "To Do", "In Progress", "Review", "Done"],
  },
];

const TAGS = ["Feature", "Bug", "Refactor", "Design", "Infra"];

export const generateMockTasks = () => {
  const tasks = [];
  const statuses = ["Backlog", "To Do", "In Progress", "Review", "Done"];
  const priorities = ["Low", "Medium", "High", "Critical"];

  for (let i = 1; i <= 40; i++) {
    // Increased count to populate multiple projects
    const isDone = Math.random() > 0.8;
    const start = isDone
      ? subDays(new Date(), Math.floor(Math.random() * 20))
      : subDays(new Date(), Math.floor(Math.random() * 5));
    const due = addDays(start, Math.floor(Math.random() * 10) + 2);

    // Assign 1 or 2 random users
    const assigneeCount = Math.random() > 0.7 ? 2 : 1;
    const shuffledUsers = [...MOCK_USERS].sort(() => 0.5 - Math.random());
    const assigneeIds = shuffledUsers.slice(0, assigneeCount).map((u) => u.id);

    // Assign to random project
    const project =
      MOCK_PROJECTS[Math.floor(Math.random() * MOCK_PROJECTS.length)];

    // Mock Checklist
    const checklist = [];
    if (Math.random() > 0.5) {
      checklist.push({
        id: `cl-${i}-1`,
        text: "Initial research",
        isCompleted: true,
        assigneeId: assigneeIds[0],
      });
      checklist.push({
        id: `cl-${i}-2`,
        text: "Draft implementation",
        isCompleted: isDone,
        assigneeId: assigneeIds[0],
      });
      checklist.push({
        id: `cl-${i}-3`,
        text: "Code review",
        isCompleted: false,
      });
    }

    // Mock Attachments
    const attachments = [];
    if (Math.random() > 0.7) {
      attachments.push({
        id: `att-${i}`,
        name: "specs_v1.pdf",
        url: "#",
        type: "pdf",
        size: "2.4 MB",
        uploadedAt: start.toISOString(),
      });
    }

    // Mock Comments
    const comments = [];
    if (Math.random() > 0.6) {
      comments.push({
        id: `cm-${i}`,
        userId: MOCK_USERS[Math.floor(Math.random() * MOCK_USERS.length)].id,
        text: "Looks good, but we need to check the requirements again.",
        createdAt: addDays(start, 1).toISOString(),
      });
    }

    tasks.push({
      id: `t-${i}`,
      projectId: project.id,
      title: `${project.key}-${i}: ${
        [
          "Fix login bug",
          "Update dashboard",
          "API Migration",
          "User Research",
          "Database optimize",
        ][i % 5]
      }`,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.",
      priority: priorities[Math.floor(Math.random() * priorities.length)],
      status: isDone
        ? "Done"
        : statuses[Math.floor(Math.random() * (statuses.length - 1))],
      assigneeIds: assigneeIds,
      startDate: start.toISOString(),
      dueDate: due.toISOString(),
      estimateHours: Math.floor(Math.random() * 20) + 2,
      tags: [TAGS[Math.floor(Math.random() * TAGS.length)]],
      progress: isDone ? 100 : Math.floor(Math.random() * 80),
      checklist: checklist,
      attachments: attachments,
      comments: comments,
      activityLog: [
        { id: `l-${i}`, text: "Task created", createdAt: start.toISOString() },
      ],
    });
  }
  return tasks;
};

export const getStatusColor = (status) => {
  switch (status) {
    case "Backlog":
      return "bg-slate-100 text-slate-700 border-slate-200";
    case "To Do":
      return "bg-blue-50 text-blue-700 border-blue-200";
    case "In Progress":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "Review":
      return "bg-purple-50 text-purple-700 border-purple-200";
    case "Done":
      return "bg-green-50 text-green-700 border-green-200";
    default:
      return "bg-gray-100";
  }
};

export const getPriorityColor = (priority) => {
  switch (priority) {
    case "Low":
      return "bg-slate-100 text-slate-600";
    case "Medium":
      return "bg-blue-100 text-blue-700";
    case "High":
      return "bg-orange-100 text-orange-700";
    case "Critical":
      return "bg-red-100 text-red-700";
  }
};
